export const orderConstants = {
    OneTimeChargesTxt : "You'll pay your one-time charges with your first bill.",
    DueMonthlyTxt: "Monthly total is an estimate. Taxes & fees are extra.",
    offerLinkTxt: 'Offer, pricing and service details',
    setupFeeWaived: 'Online exclusive: <br/>$99 Standard setup fee waived',
    noPerksTxt: 'Save on every perk. Just $10/mo each.',
    noPerksCreditnoMobileTxt: "Select an eligible perk to get up to $10/mo credit.",
    noPerksCreditTxt: "Select an eligible perk to get up to $10/mo credit. Otherwise, the credit will be applied to an existing perk on your mobile bill.",
    noPerksYoutubeTxt: "Add YouTube Premium to receive 6 months, on us",
    professionalInstallation: 'Professional installation',
    promoCode: 'Add promo code',
    errorMessage : 'Invalid or expired code. Please try a different one.',
    errorMessageInitially:'Enter a promo code to proceed.',
    successMessage: "Promo code applied",
    youTubePerkRecommendSubtxt: 'YouTube Premium for 6 months, on us',
    youTubePerkRecommendHeadtxt: 'Don’t miss out on our special gift!'
}